export default "d3093f59c953062b.ttf"